import {
  CalendarIcon,
  MenuIcon,
  EditIcon,
  FolderIcon,
  StampIcon,
  ThreeDotsIcon,
} from '@assets/icons';
import { CardEditalContainer } from '@components/CardEdital/styles';
import { formatDateTimeBR } from '@utils/formatDateTimeBR';
import { Edital } from '@libs/types';
import { useState } from 'react';
import { EditalDetailsModal } from '../EditalDetailsModal';
import { EditalDownloadModal } from '../EditalDownloadModal';
import { getEdital } from '../../api/EditaisService';

type CardEditalProps = {
  edital: Edital;
};

export const CardEdital = ({ edital }: CardEditalProps) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isEditalDetailsOpen, setIsEditalDetailsOpen] = useState(false);
  const [editalCurrent, setEditalCurrent] = useState<Edital | null>(edital);
  const [hasLoadedDetail, setHasLoadedDetail] = useState(false);

  const handleOpenEdital = () => {
    setIsOpenModal(true);
  };

  const situacaoStatus = [
    {
      label: 'Não iniciado',
      value: 1,
    },
    {
      label: 'Em execução',
      value: 2,
    },
    {
      label: 'Encerrado',
      value: 3,
    },
  ];

  const getSituacaoLabel = (value: number | string) => {
    const status = situacaoStatus.find((option) => option.value === value);
    return status ? status.label : 'Unknown';
  };

  const fetchEditalInfo = () => {
    // Sem uniqueId (ex.: card de mock/estado vazio) não há detalhe a buscar —
    // evita um GET InformacoesAdicionais/ que falharia com id inválido.
    if (!edital.uniqueId) return;

    try {
      getEdital(edital.uniqueId).then((result) => {
        setEditalCurrent(result);
        setHasLoadedDetail(true);
      });
    } catch (err) {
      console.log(err);
    }
  };

  const handleOpenEditalDetails = () => {
    // O detalhe (InformacoesAdicionais) só é buscado ao abrir "Exibir Mais",
    // e uma única vez por card — não no carregamento da Home.
    if (!hasLoadedDetail) fetchEditalInfo();
    setIsEditalDetailsOpen(true);
  };

  return (
    <CardEditalContainer
      style={{
        display: window.innerWidth < 900 ? 'block' : 'flex',
        padding: window.innerWidth < 900 ? '1em' : '0',
      }}
    >
      <div className="big-container">
        {window.innerWidth > 900 && (
          <div className="header-row">
            <div className="titles">
              <span>Nome do Órgão Promotor</span>
              <h6 className="name">{edital.nomeDoOrgaoPromotor}</h6>
            </div>

            {[
              {
                icon: <CalendarIcon />,
                label: 'Data publicação',
                value: formatDateTimeBR(editalCurrent?.publishedAt),
              },
              {
                icon: <StampIcon />,
                label: 'Modalidade',
                value: edital?.modalidade || '-',
              },
              {
                icon: <CalendarIcon />,
                label: 'Termino de Recebimento das Propostas',
                value: formatDateTimeBR(editalCurrent?.terminoDeRecebimento),
              },
            ].map((item, index) => (
              <div key={index} className="row-info">
                <div className="icon">{item.icon}</div>
                <div className="info">
                  <label>{item.label}</label>
                  <span>{item.value}</span>
                </div>
              </div>
            ))}
          </div>
        )}
        {window.innerWidth <= 900 && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <div className="titles">
              <span>Nome do Órgão Promotor</span>
              <h6 className="name">{edital.nomeDoOrgaoPromotor}</h6>
            </div>

            {[
              {
                icon: <CalendarIcon />,
                label: 'Data publicação',
                value: formatDateTimeBR(editalCurrent?.publishedAt),
              },
              {
                icon: <StampIcon />,
                label: 'Modalidade',
                value: edital?.modalidade || '-',
              },
              {
                icon: <CalendarIcon />,
                label: 'Termino de Recebimento das Propostas',
                value: formatDateTimeBR(editalCurrent?.terminoDeRecebimento),
              },
            ].map((item, index) => (
              <div key={index} className="row-info">
                <div className="icon">{item.icon}</div>
                <div className="info">
                  <label>{item.label}</label>
                  <span>{item.value}</span>
                </div>
              </div>
            ))}
          </div>
        )}
        {window.innerWidth > 900 && <hr />}
        <section
          className="infos second-row"
          style={{
            display: window.innerWidth < 900 ? 'flex' : 'grid',
            flexDirection: 'column',
          }}
        >
          {[
            {
              icon: <FolderIcon />,
              label: 'Objeto',
              value: edital.objeto.split('-')[0],
            },
            {
              icon: <EditIcon />,
              label: 'Edital',
              value: edital?.numeroDoEdital || '-',
            },
            {
              icon: <ThreeDotsIcon />,
              label: 'Situação',
              value: edital.SituacaoNome ?? '-',
            },
          ].map((item, index) => (
            <div key={index} className="row-info">
              <div className="icon">{item.icon}</div>
              <div className="info">
                <label>{item.label}</label>
                <span>{item.value}</span>
              </div>
            </div>
          ))}

          <div className="details">
            <div className="menu-icon">
              <MenuIcon />
            </div>
            <button onClick={handleOpenEditalDetails}>Exibir Mais</button>
          </div>
        </section>

        {isEditalDetailsOpen && editalCurrent && (
          <EditalDetailsModal
            edital={editalCurrent}
            isOpen={isEditalDetailsOpen}
            onClose={() => setIsEditalDetailsOpen(false)}
          />
        )}

        {isOpenModal && (
          <EditalDownloadModal
            edital={editalCurrent}
            isOpen={isOpenModal}
            setEditalInfo={setEditalCurrent}
            onClose={() => setIsOpenModal(false)}
          />
        )}
      </div>
    </CardEditalContainer>
  );
};
